export default __webpack_public_path__ + "static/media/sticker_mask_reduced.745d352f.jpg";